export const GET_INSTALLATIONS_LIST_IN_PROGRESS =
  "GET_INSTALLATIONS_LIST_IN_PROGRESS";
export const GET_INSTALLATIONS_LIST_SUCCESS = "GET_INSTALLATIONS_LIST_SUCCESS";
export const GET_INSTALLATIONS_LIST_FAIL = "GET_INSTALLATIONS_LIST_FAIL";

export const GET_INSTALLATIONS_FILTERS_IN_PROGRESS =
  "GET_INSTALLATIONS_FILTERS_IN_PROGRESS";
export const GET_INSTALLATIONS_FILTERS_SUCCESS = "GET_INSTALLATIONS_FILTERS_SUCCESS";
export const GET_INSTALLATIONS_FILTERS_FAIL = "GET_INSTALLATIONS_FILTERS_FAIL";

export const GET_INSTALLATIONS_COUNT_IN_PROGRESS =
  "GET_INSTALLATIONS_COUNT_IN_PROGRESS";
export const GET_INSTALLATIONS_COUNT_SUCCESS = "GET_INSTALLATIONS_COUNT_SUCCESS";
export const GET_INSTALLATIONS_COUNT_FAIL = "GET_INSTALLATIONS_COUNT_FAIL";

export const IMPORT_INSTALLATIONS_IN_PROGRESS =
  "IMPORT_INSTALLATIONS_IN_PROGRESS";
export const IMPORT_INSTALLATIONS_SUCCESS = "IMPORT_INSTALLATIONS_SUCCESS";
export const IMPORT_INSTALLATIONS_FAIL = "IMPORT_INSTALLATIONS_FAIL";

export const IMPORT_COMPRESSORS_IN_PROGRESS =
  "IMPORT_COMPRESSORS_IN_PROGRESS";
export const IMPORT_COMPRESSORS_SUCCESS = "IMPORT_COMPRESSORS_SUCCESS";
export const IMPORT_COMPRESSORS_FAIL = "IMPORT_COMPRESSORS_FAIL";

export const GET_INSTALLATION_INFO_IN_PROGRESS =
  "GET_INSTALLATION_INFO_IN_PROGRESS";
export const GET_INSTALLATION_INFO_SUCCESS = "GET_INSTALLATION_INFO_SUCCESS";
export const GET_INSTALLATION_INFO_FAIL = "GET_INSTALLATION_INFO_FAIL";

export const UPDATE_INSTALLATION_IN_PROGRESS =
  "UPDATE_INSTALLATION_IN_PROGRESS";
export const UPDATE_INSTALLATION_SUCCESS = "UPDATE_INSTALLATION_SUCCESS";
export const UPDATE_INSTALLATION_FAIL = "UPDATE_INSTALLATION_FAIL";

export const RESET_INSTALLATION_STATE = "RESET_INSTALLATION_STATE";
